import axios from 'axios';

const apiPdca = axios.create({
  baseURL: `${process.env.REACT_APP_INSV_API_V5}`
});
apiPdca.interceptors.request.use(async (config) => {
  const token = localStorage.tolkenINSV;

  if (token)
    config.headers.authorization = `${token}`;

  return config;
});

apiPdca.interceptors.response.use(
  (response) => {
    return response;
  },
  
  (err) => Promise.reject(err)
);

export default apiPdca
